export default __webpack_public_path__ + "static/monogram-background-80fba1d91bd93f1c4fe1603629255e2f.jpg";